import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  formInputLabel: {
    padding: 0,
    marginBottom: 8,
    fontWeight: '600 !important',
    fontSize: 16,
    lineHeight: '24px',
  },
  textFieldStyle: {
    '&.MuiTextField-root': {
      width: '100%',
    },
    '& .MuiInputBase-input': {
      padding: '16px 14px',
    },
  },
  wrapFormInput: {
    marginTop: 0,
    position: 'relative',
  },
}));

export default useStyles;
